<template>
  <div class="search-warp">
    <adv-item adv-postion-name="search_top_0" />
    <div class="search-container">
      <div class="div-layout div-search">
        <ul class="type">
          <span>类型：</span>
          <div class="max-box">
            <div class="box">
              <li
                v-for="(item, index) in typeList"
                :key="index"
                :class="active === item.id ? 'code-tab' : ''"
                :title="item.name"
                @click="typeChanage(item, index)"
              >
                {{ item.name }}
              </li>
            </div>
          </div>
          <div class="right">
            <el-input
              v-model="searchText"
              placeholder="请输入搜素内容"
              class="search-input"
              @keyup.enter.native="searchCon"
            >
              <img
                id="searchCon"
                slot="append"
                class="search-img"
                src="@/assets/img/icon-search.png"
                alt=""
                @click="searchCon"
              >
            </el-input>
            <span
              v-show="code !== 'all' && code !== 'S99'"
              class="result-text"
            >搜索结果：<i>{{ resultCount }}条</i></span>
          </div>
        </ul>
      </div>
      <div v-if="code === 'all'">
        <div v-for="(item, index) in allViewList" :key="index">
          <div class="div-layout">
            <div class="search-result">
              <div>
                <span class="result-title">{{ searchT | titleFilter }}-</span>
                {{ item.name }}
              </div>
              <div>
                <span
                  class="more"
                  @click="more(item.code, item.id)"
                >查看更多</span>
              </div>
            </div>
            <TabListApp
              v-if="item.code === 'S01'"
              :search-click="searchClick"
              :wd="searchT"
            />
            <TabListResoure
              v-if="item.code === 'S02'"
              :search-click="searchClick"
              :wd="searchT"
            />
            <TabListTeacher
              v-if="item.code === 'S03'"
              :search-click="searchClick"
              :wd="searchT"
            />
            <TabList
              v-if="item.code === 'S04'"
              :wd="searchT"
              :search-click="searchClick"
              :code="item.code"
              :is-pagination="false"
            />
            <TabList
              v-if="item.code === 'S05'"
              :wd="searchT"
              :search-click="searchClick"
              :code="item.code"
              :is-pagination="false"
            />
            <TabList
              v-if="item.code === 'S13'"
              :wd="searchT"
              :search-click="searchClick"
              :code="item.code"
              :is-pagination="false"
            />
            <SchoolStyle
              v-if="item.code === 'S14'"
              :search-click="searchClick"
              :wd="searchT"
            />
          </div>
          <div v-if="index === 0 && allViewList.length !== 1">
            <adv-item adv-postion-name="search_center_0" />
          </div>
          <div v-if="index === 2 && allViewList.length !== 3">
            <adv-item adv-postion-name="search_center_1" />
          </div>
        </div>
      </div>
      <div v-else-if="code === 'S04'" class="div-layout">
        <!-- 资讯 -->
        <TabList :search-click="searchClick" :wd="searchT" :code="code" />
      </div>
      <div v-else-if="code === 'S05'" class="div-layout">
        <!-- 公示公告 -->
        <TabList :search-click="searchClick" :wd="searchT" :code="code" />
      </div>
      <div v-else-if="code === 'S13'" class="div-layout">
        <!-- 校园动态 -->
        <TabList :search-click="searchClick" :wd="searchT" :code="code" />
      </div>
      <!-- <div v-else-if="code === 'S14'" class="div-layout">
        <TabList :search-click="searchClick" :wd="searchT" :code="code" />
      </div> -->
      <div v-else class="div-layout">
        <iframe
          id="iframe"
          ref="iframe"
          name="iframe"
          class="iframe"
          width="100%"
          frameborder="0"
          :src="iframeSrc"
          :scrolling="code !== 'S99' ? 'no' : ''"
        />
      </div>
    </div>
    <adv-item adv-postion-name="search_bottom_0" />
  </div>
</template>
<script>
import TabList from '@/views/search/searchNews'; // 资讯与公告
import ENVIRONMENT from '@/utils/environment';
import TabListApp from '@/views/module/moduleList/interactiveTeaApp/tabList'; // 应用
import TabListResoure from '@/views/module/moduleList/resoure/tabList'; // 资源
import TabListTeacher from '@/views/module/moduleList/famousTeaSpecialarea/tabList'; // 名师
import SchoolStyle from '@/views/schoolStyle/tabList'; // 学校
import { getSearchItem } from '@/api/search';
import { mapGetters } from 'vuex';

export default {
  name: 'Search',
  components: {
    TabList,
    TabListApp,
    TabListResoure,
    SchoolStyle,
    TabListTeacher
  },
  data: () => {
    return {
      resultCount: '', // 搜索结果
      searchText: '',
      code: 'all',
      id: '',
      searchT: '猜你喜欢',
      searchClick: '',
      iframeSrc: '',
      pageNum: 0,
      active: 'all',
      iframeUrl: '',
      pageSize: 10,
      total: 0,
      clickTabFlag: false, // 是否点击tab分类
      typeList: [],
      allViewList: [] // 全部类型中非第三方分类列表
    };
  },
  computed: {
    ...mapGetters(['advList'])
  },
  watch: {
    $route: {
      handler: function(route) {
        this.active = route.params.id;
        this.code = route.params && route.params.searchClass;
        this.searchT = (route.query && route.query.wd) || '';
        this.searchText = this.searchT;
      },
      immediate: true
    },
    active(val) {
      this.$router.push({
        path: '/search/' + this.code + '/' + val,
        query: { wd: this.searchT }
      });
    },
    searchT(val) {
      this.$router.push({
        path: '/search/' + this.code + '/' + this.active,
        query: { wd: val }
      });
    }
  },
  mounted() {
    this.getSearchItem();
    window.addEventListener(
      'message',
      res => {
        // iframe通信
        this.$nextTick(() => {
          if ((res.data.result || res.data.height) && this.code !== 'all') {
            this.resultCount = res.data.result;
            this.setIframeHeight(
              document.getElementById('iframe'),
              res.data.height
            );
          }
        });
      },
      false
    );
  },
  methods: {
    setIframeHeight(iframe, height) {
      if (!iframe) return;
      iframe.height = height + 180;
    },
    async getSearchItem() {
      await getSearchItem().then(res => {
        this.typeList = [
          {
            id: 'all',
            code: 'all',
            name: '全部'
          },
          ...res.data
        ];
        this.allViewList = res.data.filter(item => {
          if (item.code !== 'S99') {
            return item;
          }
        });
        this.typeList.map(item => {
          if (item.id === this.active) {
            this.iframeUrl = item.outsideUrl;
            if (this.code === 'S99') {
              const temp = this.iframeUrl.toString();
              this.iframeSrc = temp + this.searchT;
              this.$nextTick(() => {
                this.setIframeHeight(document.getElementById('iframe'), 700);
              });
            } else {
              this.iframeSrc =
                ENVIRONMENT.BASE_URL +
                '/searchResult/' +
                this.code +
                '?wd=' +
                this.searchT;
            }
          }
        });
      });
      var index = localStorage.getItem('index') || 0;
      this.moveTab(index);
    },
    searchCon() {
      // 点击搜索按钮
      this.searchT = this.searchText;
      this.searchClick = Math.random().toString();
      if (this.code === 'S99') {
        const temp = this.iframeUrl.toString();
        this.iframeSrc = temp + this.searchT;
        this.$nextTick(() => {
          this.setIframeHeight(document.getElementById('iframe'), 700);
        });
      } else {
        console.log(123);
        this.iframeSrc =
          ENVIRONMENT.BASE_URL +
          '/searchResult/' +
          this.code +
          '?wd=' +
          this.searchT +
          '&yxz=' +
          this.searchClick;
      }
    },
    typeChanage(type, index) {
      // 点击tab分类
      this.code = type.code;
      this.active = type.id;
      this.iframeUrl = type.outsideUrl;
      this.clickTabFlag = true;
      localStorage.setItem('index', index);
      this.moveTab(index);
      this.searchCon();
    },
    more(code, id) {
      // 查看更多
      this.active = id;
      this.typeList.map((item, index) => {
        if (item.id === id) {
          this.moveTab(index);
        }
      });
      this.code = code;
      document.querySelector('#top').scrollIntoView(true);
      this.iframeSrc =
        ENVIRONMENT.BASE_URL + '/searchResult/' + code + '?wd=' + this.searchT;
    },
    moveTab(index) {
      // 移动tab
      var list = [];
      var bian = 40;
      for (var i = 0; i < this.typeList.length; i++) {
        bian += document.querySelector('.box').childNodes[i].clientWidth;
        list.push(bian);
        bian += 40;
      }
      var num =
        list[index] -
        300 -
        Number(
          document.querySelector('.box').childNodes[index].clientWidth / 2
        ) +
        100;
      const num1 = document.querySelector('.box').scrollWidth - 600;
      if (num > 0 && num < num1) {
        document.querySelector('.box').style.marginLeft = '-' + num + 'px';
      } else if (num > num1) {
        document.querySelector('.box').style.marginLeft =
          '-' + (num1 + 10) + 'px';
      } else {
        document.querySelector('.box').style.marginLeft = '0px';
      }
    },
    resultCountClick(data) {
      // 回调查询统计结果
      this.resultCount = data;
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
/deep/ .text-div {
  margin-bottom: 0;
}
/deep/ .carousel .div-layout-warp {
  margin: 0;
}

.div-layout {
  margin-bottom: 20px;
}
.search-warp {
  .search-container {
    background-color: #f0f2f5;
    // margin-top: 20px;
  }
  .resoure {
    .box-card {
      margin: 10px 0;
    }
  }
  .breadcrumb {
    padding: 20px 0;
  }
  .search-item {
    border-bottom: #f3f3f3 solid 1px;
    padding: 12px 0;
  }
  .result-title {
    font-weight: bold !important;
    font-size: 18px !important;
  }
  .more {
    cursor: pointer;
  }
  .search-result {
    display: flex;
    justify-content: space-between;
    padding: 20px 0 0 0;
    margin: 0 16px 0 20px;
    font-weight: bold;
    font-size: 18px;
    div {
      font-size: 18px;
      color: #787878;
      font-weight: 500;
    }
    span {
      color: #0082f1;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
    }
  }
  .type li:first-of-type {
    margin: 0px 0px 0 5px;
  }
  .type {
    display: flex;
    span {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 27px;
    }
    padding-top: 10px;
    li {
      display: inline-block;
      padding: 4px 10px;
      // margin: 0 23px;
      vertical-align: baseline;
      margin-left: 40px;
      border-radius: 4px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      cursor: pointer;
      max-width: 200px;
      overflow: hidden; // 超出的文本隐藏
      text-overflow: ellipsis; // 溢出用省略号显示
      white-space: nowrap; // 溢出不换行
      &.code-tab {
        background: #1f87e6;
        color: #fff;
      }
    }
  }
}
.search-input {
  width: 300px;
}
.main-div {
  border-radius: 0;
  margin-top: 0;
}
.div-search {
  box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.05);
  padding: 11px 40px;
  z-index: 99;
  position: relative;
  height: 68px;
  top: 0;
  margin-bottom: -2px;
}
/deep/ .el-input-group__append,
.el-input-group__prepend {
  padding: 0 !important;
  border: none;
}
.search-img {
  width: 40px !important;
  height: 36px !important;
  cursor: pointer;
}
.result-text {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #cacaca;
  margin-left: 19px;
}
.right {
  position: absolute;
  right: 40px;
  top: 15px;
}
.box {
  white-space: nowrap;
  position: absolute;
  transition: margin-left 1.5s;
}
.max-box {
  position: relative;
  overflow: hidden;
  width: 600px;
}
</style>
